<template>
  <div
    id="page-wrapper"
    class="wrap-container wrap-container--has-margin-bottom category-page"
    role="main"
  >
    <on-page-breadcrumbs :data="breadcrumbs" />
    <hero-block
      v-bind="heroBlock"
      edit-prefix="HeroBlock"
      :image-sizes="size"
      :one-url-epi-picture="true"
    />

    <navigation-blocks
      v-if="matchingTags.length"
      :navigation-blocks="matchingTags"
      :display-image-state="false"
      :show-more-limit="!isEditable ? ($root.isSmallViewport ? 2 : 4) : 0"
      :show-more-all="false"
    >
      <sub-heading
        v-if="matchingTagsTitle || isEditable"
        :v-edit-heading="'MatchingTagsTitle'"
        :heading="matchingTagsTitle"
      />
    </navigation-blocks>

    <section
      v-if="contentAreaTitle && contentArea.length || isEditable"
      class="content-area-wrapper"
    >
      <sub-heading
        v-if="contentAreaTitle || isEditable"
        :v-edit-heading="'ContentAreaTitle'"
        :heading="contentAreaTitle"
      />

      <block-grid
        v-if="contentArea.length || (isEditable && contentArea.length)"
        v-edit="'ContentArea'"
        :blocks="contentArea"
        :custom-size="fixedSizeFullFirstAllSizes"
        :tracking="{
          listName: contentAreaTitle,
          listLength: undefined
        }"
      />
    </section>

    <section
      v-if="itemLists.articles || isEditable"
      ref="articles"
      class="content-area-wrapper"
    >
      <sub-heading
        v-if="articleBlockTitle || isEditable"
        :v-edit-heading="'ArticleBlockTitle'"
        :heading="articleBlockTitle"
      />

      <block-grid
        :blocks="itemLists.articles"
        :custom-size="fixedSizeFullFirst"
        :force-row-size="'third'"
        :tracking="{
          listName: articleBlockTitle,
          listLength: undefined
        }"
      />

      <show-more
        v-if="moreApiUrls.articles"
        :api-url="moreApiUrls.articles"
        :tracking="{
          event: 'articleShowMore'
        }"
        @showMoreResult="showMoreAddToList('articles', ...arguments)"
      />
    </section>

    <section
      v-if="(itemLists.recipes && itemLists.recipes.length) || isEditable"
      ref="recipes"
      class="content-area-wrapper"
    >
      <sub-heading
        v-if="recipeBlockTitle || isEditable"
        :v-edit-heading="'RecipeBlockTitle'"
        :heading="recipeBlockTitle"
      />

      <block-grid
        :blocks="itemLists.recipes"
        :custom-size="fixedSizeFullFirst"
        :force-row-size="'third'"
        :tracking="{
          listName: recipeBlockTitle,
          listLength: undefined
        }"
        @open-folder-modal="openFolderModal"
      />

      <show-more
        v-if="moreApiUrls.recipes"
        :api-url="moreApiUrls.recipes"
        :tracking="{
          event: 'recipeShowMore'
        }"
        @showMoreResult="showMoreAddToList('recipes', ...arguments)"
      />
    </section>

    <section
      v-if="(itemLists.recipeCollections && itemLists.recipeCollections.length) || isEditable"
      ref="recipeCollections"
      class="content-area-wrapper"
    >
      <sub-heading
        v-if="recipeCollectionBlockTitle || isEditable"
        :v-edit-heading="'RecipeCollectionBlockTitle'"
        :heading="recipeCollectionBlockTitle"
      />

      <block-grid
        :blocks="itemLists.recipeCollections"
        :custom-size="fixedSizeFullFirst"
        :force-row-size="'third'"
        :tracking="{
          listName: recipeCollectionBlockTitle,
          listLength: undefined
        }"
      />

      <show-more
        v-if="moreApiUrls.recipeCollections"
        :api-url="moreApiUrls.recipeCollections"
        :tracking="{
          event: 'recipeCollectionShowMore'
        }"
        @showMoreResult="showMoreAddToList('recipeCollections', ...arguments)"
      />
    </section>
    <ica-add-single-recipe-to-folder-modal
      v-if="$root.isLoggedIn"
      :active="showFolderModal"
      :recipe-id="activeRecipeId"
      :recipe-name="activeRecipeTitle"
      :get-access-token-fn="getPublicAccessToken"
      :recipe-base-url="$root.envConfig.recipeExperienceApiBaseUrl"
      @save-to-folder="saveToFolder"
      @close-modal="closeModal"
    />
  </div>
</template>

<script>
import pageWithNavigation from '@/vue/mixins/pageWithNavigation'
import showMore from '@/vue/components/common/showMore'
import showMoreMixin from '@/vue/mixins/showMoreMixin'
import recipeModalMixin from '@/vue/mixins/recipeModalMixin'

export default {
  name: "CategoryPage",
  components: {
    showMore
  },
  mixins: [pageWithNavigation, showMoreMixin, recipeModalMixin],
  props: {
    breadcrumbs: {
      type: Array,
      default: () => []
    },
    heroBlock: {
      type: Object,
      default: () => {}
    },
    matchingTagsTitle: {
      type: String,
      default: ''
    },
    displayImagesInNavigationBlocks: {
      type: Boolean,
      default: false
    },
    matchingTags: {
      type: Array,
      default: () => []
    },
    matchingTagsNavigations: {
      type: Array,
      default: () => []
    },
    contentAreaTitle: {
      type: String,
      default: ''
    },
    contentArea: {
      type: Array,
      default: () => []
    },
    articleBlockTitle:{
      type: String,
      default: 'Artiklar'
    },
    automatedArticleArea: {
      type: Array,
      default: () => []
    },
    recipeCollectionBlockTitle: {
      type: String,
      default: 'Receptsamlingar'
    },
    recipeBlockTitle: {
      type: String,
      default: 'Recept'
    },
    automatedRecipeArea: {
      type: Array,
      default: () => []
    }
    // ShowMore-mixin contains important props!
  },
  data () {
      return {
        size: {
          large: {
            height: 820,
            width: 1232
          }
        },
        fixedSizeFullFirst: {
          isSmallViewport: {
            size: "full"
          }
        },
        fixedSizeFullFirstAllSizes: {
          isSmallViewport: {
            size: "full",
          },
          isMediumViewport: {
            size: "full",
            firstOnly: true
          },
          isLargeViewport: {
            size: "full",
            firstOnly: true
          }
        },
      }
    },
}
</script>
